import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { AttioLinkedService } from 'app/model/linkedservice/attio.linkedservice';
import { AttioCopySource } from 'app/model/pipeline/copysource/attio.copysource';
import { GlobalVariables } from 'app/services/globals';
import { ConnectionAuthKind } from 'shell-models-lib';

export const attioMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(AttioLinkedService).name,
    disabled: !GlobalVariables.enableAttioConnector,
    displayName: 'Attio',
    linkedServiceKind: 'table',
    linkedServiceNamePrefix: 'Attio',
    icon: {
        className: 'svg-i-100x100-REST'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    supportedInTrident: GlobalVariables.enableAttioConnector,
    supportAutoFillCopilotInput: GlobalVariables.enableAttioConnector,
    isKnownInPipelineContext: GlobalVariables.enableAttioConnector,
    supportedAuthKindsInTrident: [ConnectionAuthKind.Key],
    supportCopyJobSource: GlobalVariables.enableAttioConnector,
    supportOPDG: GlobalVariables.enableAttioConnector && GlobalVariables.enableOPDG,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'Attio' as ResourceKind
    },
    category: ['ServicesApps'],
    copySourceTypes: [Metamodel.modelFor(AttioCopySource).name],
    copySinkTypes: [],
    supportFirstClassParameterExperience: true
};
